module.exports = __webpack_public_path__ + "static/media/Stellar Ark King Headboard - 180 cm.29b4c8c7.jpg";